export const replacedTextData = {
  BLM: 'MLO',
  'Broker Loan Manager': 'Mortgage Loan Officer',
};
